export default "__VITE_ASSET__Cf_WIbAK__"